// removed by extract-text-webpack-plugin
module.exports = {"listTable":"index__listTable___117AG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/ListTable/index.less
// module id = 1155
// module chunks = 3